import React from "react";

class FileInput extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isValid: false,
      file: null,
      fresh: true,
      reset: () => this.reset()
    };
  }

  reset() {
    this.setState({
      isValid: false,
      fresh: true,
      file: null
    });
  }

  onChange(e) {
    const file = e.target.files[0];

    let isValid = file !== undefined;
    if (isValid && !file.type.startsWith("image/")) {
      this.reset();
      return;
    }

    this.setState({ file: file, isValid: isValid, fresh: false });
  }

  render() {
    const { placeholder, accept } = this.props;
    const { value, file } = this.state;

    const _accept = accept ? accept : "image/*";

    //const isValid = this.state.fresh ? true : this.state.isValid;

    const label = file ? file.name : placeholder;

    return (
      <div className="FileInput">
        <label htmlFor="ojkqfe">
          {label}
          <i className="fas fa-file-upload" />
        </label>
        <input
          id="ojkqfe"
          type="file"
          accept={_accept}
          value={value}
          onChange={e => this.onChange(e)}
        />
      </div>
    );
  }
}

export default FileInput;



// WEBPACK FOOTER //
// ./src/components/FileInput.js